module.exports = __webpack_public_path__ + "media/images/career_camp/2023/blurred_tree_2-26b799571d623c82ccf8d53fccfa48e9.png";